/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import { Button, Menu, MenuItem, Intent, Popover, Position } from '@blueprintjs/core';
import { Timeline, TimelineBinResolution } from './timeline';
import { TemporalSelector } from './temporalSelector';
import { useContext } from 'react';
import { ErrorBoundary } from 'components/errorBoundary';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import { WorkspaceContext } from 'views/workspace/workspaceContext';
import { Sizes } from 'styles/variables-slykit';

interface Props extends React.ComponentProps<'div'> {}

export function clearTimelineFilter(dispatch, timeline) {
	dispatch(
		WorkspaceActionCreator.updateFilter('timeline', {
			...timeline,
			timeExtents: null,
		})
	);
	dispatch(WorkspaceActionCreator.updateQueryString('timeline', null));
}

export const TimelineWrapper: React.FC<Props> = (props) => {
	const {
		state: {
			explorer: {
				filters: { timeline },
			},
		},
		dispatch,
	} = useContext(WorkspaceContext);

	function clearTimeFilter() {
		clearTimelineFilter(dispatch, timeline);
	}

	const [binningResolution, setBinningResolution] = React.useState<TimelineBinResolution>(
		TimelineBinResolution.Automatic
	);

	//Future: Right now, this is just binning options. We'll need a better design if this menue needs to include more options.
	const CreateSettingsDropdownContent = React.useCallback(() => {
		return (
			<Menu>
				{Object.keys(TimelineBinResolution).map((keyName) => {
					return (
						<MenuItem
							key={keyName}
							text={keyName}
							onClick={() => setBinningResolution(TimelineBinResolution[keyName])}
							intent={TimelineBinResolution[keyName] === binningResolution ? Intent.PRIMARY : Intent.NONE}
						/>
					);
				})}
			</Menu>
		);
	}, [binningResolution]);

	return (
		<div css={wrapperStyle} {...props}>
			<ErrorBoundary retryButtonText={'Retry'} description={null}>

				<div css={headerStyle}>

					<div css={temporalSelectorWrapperStyle}>
						<strong css={temporalSelectorLabelStyle}>
							Time Filter:
						</strong>
						<div css={temporalSelectorMarginsStyle}>
							<TemporalSelector />
						</div>
					</div>

					<div css={buttonWrapperStyle}>
						<Button minimal onClick={clearTimeFilter} icon="reset" />
						<Popover content={<CreateSettingsDropdownContent />} position={Position.BOTTOM_LEFT} boundary={'viewport'}>
							<Button minimal icon="more" style={{ transform: 'rotate(90deg)' }} />
						</Popover>
					</div>

				</div>

				<Timeline maxBinResolution={binningResolution} />

			</ErrorBoundary>
		</div>
	);
};

const wrapperStyle = css`
	width: 100%;
	height: 100%;
	/* overflow: hidden; */ // necessary only in some cases?
	display: flex;
	flex-direction: column;
	padding: ${Sizes.xxsm} ${Sizes.md};
`;
const headerStyle = css`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: space-between;
`;
const temporalSelectorWrapperStyle = css`
	display: flex;
	align-items: center;
	align-content: flex-start;
	flex-wrap: wrap;
`;
const temporalSelectorLabelStyle = css`
	margin-right: 12px; // space from temporalSelectorMarginsStyle{margin-left: -8px;}
`
const temporalSelectorMarginsStyle = css`
	margin-left: -8px; // visually left-align button content when wrapped
`
const buttonWrapperStyle = css`
	margin-right: -7px; // visually right-align button content
	display: flex;
	align-items: center;
`;
